import { ResourceType_Imaging, ResourceType_Laboratory } from '@app/hcs-shared';
export const ABTestValue = {
    Disabled: 'disabled',
    Enabled_DefaultTrue: 'enabledDefaultTrue',
    Enabled_DefaultFalse: 'enabledDefaultFalse',
};
/** Resource families that can receive the advisor-configuration id suffix. */
export const IdAffixFamilyByResourceType = {
    [ResourceType_Laboratory]: 'labs',
    [ResourceType_Imaging]: 'radiology',
};
//# sourceMappingURL=types.js.map